export default __webpack_public_path__ + "static/media/logo-rtl.63a90e39.svg";